import { getBlogSquareThumbnailUrl, getEstimateReadingTime } from 'lib/utilities'
import Link from 'next/link'
import { BlogPost } from 'types/strapi/blog-posts'

type CategoryPostCardProps = {
  post: BlogPost
}

export default function CategoryPostCard({ post }: CategoryPostCardProps) {
  return (
    <div className="flex w-full justify-center py-4">
      <div className="relative h-[300px] w-[300px] overflow-hidden rounded-[20px] sm:h-[600px] sm:w-[600px] md:h-[350px] md:w-[350px] lg:h-[280px] lg:w-[280px]">
        <div className="absolute z-[-2] h-full w-full">
          <img src={getBlogSquareThumbnailUrl(post)} className="h-full w-full object-cover" alt="thumbnail" />
        </div>
        <div className="absolute z-[-1] h-full w-full bg-gradient-to-t from-transparent to-black"></div>
        <div className="flex h-full flex-col justify-between p-10">
          <div>
            <div className="mb-4 text-xs text-gray-300">
              {post.attributes.publishDate &&
                new Date(post.attributes.publishDate).toLocaleDateString('en-NZ', {
                  day: '2-digit',
                  month: 'long',
                  year: 'numeric',
                })}
              <span className="px-2 font-black">·</span>
              {getEstimateReadingTime(post.attributes.content)}
            </div>
            <Link href={`/blog/${post.attributes.slug}`}>
              <a>
                <div className="mb-4 cursor-pointer text-xl font-bold text-gray-100">{post.attributes.title}</div>{' '}
              </a>
            </Link>
          </div>
          <div className="text-lg text-gray-100">{post.attributes.author}</div>
        </div>
      </div>
    </div>
  )
}
